module.exports = __webpack_public_path__ + "static/sens-logo-778a6907fbc34e39a49f68195cf93966.png";